// extracted by mini-css-extract-plugin
export var accordion = "_bu-0";
export var chevron = "_bu-3";
export var closed = "_bu-2";
export var content = "_bu-4";
export var open = "_bu-1";
export var rotate = "_bu-5";